export default __webpack_public_path__ + "static/media/medical_8.d6979193.jpg";